import {MedsRecordLogIntf} from '../crud/meds.types';
import {VapeTypesDict}     from '../crud/vape.dicts';
import {VapeRecordLogIntf} from '../crud/vape.types';
import {GlobalDictType}    from './global.types';

// export const NewGlobalDict: NewGlobalDictType<GlobalGroupType> = {
// 	body: {
// 		name  : 'Body',
// 		icon  : 'function',
// 		colors: {
// 			tw : 'lime',
// 			hex: '#ff00ff'
// 		}
// 	},
// 	caff: {
// 		name  : 'Caffeine',
// 		icon  : 'function',
// 		colors: {
// 			tw : 'lime',
// 			hex: '#ff00ff'
// 		}
// 	},
// 	food: {
// 		name  : 'Food',
// 		icon  : 'function',
// 		colors: {
// 			tw : 'lime',
// 			hex: '#ff00ff'
// 		}
// 	},
// 	hkit: {
// 		name  : 'HealthKit',
// 		icon  : 'function',
// 		dict  : HkitDict,
// 		colors: {
// 			tw : 'lime',
// 			hex: '#ff00ff'
// 		}
// 	},
// 	meds: {
// 		name  : 'Medications',
// 		icon  : 'function',
// 		colors: {
// 			tw : 'lime',
// 			hex: '#ff00ff'
// 		}
// 	},
// 	mind: {
// 		name  : 'Mind',
// 		icon  : 'function',
// 		colors: {
// 			tw : 'lime',
// 			hex: '#ff00ff'
// 		}
// 	},
// 	mood: {
// 		name  : 'Mood',
// 		icon  : 'function',
// 		colors: {
// 			tw : 'lime',
// 			hex: '#ff00ff'
// 		}
// 	},
// 	oura: {
// 		name  : 'Oura',
// 		icon  : 'function',
// 		colors: {
// 			tw : 'lime',
// 			hex: '#ff00ff'
// 		}
// 	},
// 	rize: {
// 		name  : 'Rize',
// 		icon  : 'function',
// 		colors: {
// 			tw : 'lime',
// 			hex: '#ff00ff'
// 		}
// 	},
// 	vape: {
// 		name  : 'Cannabis',
// 		icon  : 'function',
// 		colors: {
// 			tw : 'lime',
// 			hex: '#ff00ff'
// 		}
// 	}
//
// }
export const GlobalDataTypesDict: GlobalDictType = {
	vape                        : {
		name   : 'Vape',
		type   : 'vape',
		icon   : 'leaf',
		colorTw: 'lime',
		dict   : VapeTypesDict,
		tooltip: (datapoint) => {
			const d = datapoint.d as VapeRecordLogIntf
			return `${VapeTypesDict[d.type].name} ${(d.strength * 100).toFixed()}%`;
		}
	},
	meds                        : {
		name   : 'Medication',
		type   : 'meds',
		icon   : 'prescription-bottle-pill',
		colorTw: 'purple',
		tooltip: (datapoint, helper) => {
			const d = datapoint.d as MedsRecordLogIntf
			return `${helper ? helper(d.medication)?.medication : ''}`
		}
	},
	caff                        : {
		name   : 'Caffeine',
		type   : 'caff',
		icon   : 'coffee',
		colorTw: 'yellow'
	},
	food                        : {
		name   : 'Food',
		type   : 'food',
		icon   : 'burger',
		colorTw: 'green'
	},
	mood                        : {
		name   : 'Mood',
		type   : 'mood',
		icon   : 'heart',
		colorTw: 'teal'
	},
	mind                        : {
		name   : 'Mind',
		type   : 'mind',
		icon   : 'head-side-brain',
		colorTw: 'cyan'
	},
	body                        : {
		name   : 'Body',
		type   : 'body',
		icon   : 'clipboard-medical',
		colorTw: 'cyan'
	},
	active_energy               : {
		name   : 'Active Energy',
		type   : 'active_energy',
		icon   : 'flame',
		colorTw: 'white'
	},
	apple_exercise_time         : {
		name   : 'Apple Exercise Time',
		type   : 'apple_exercise_time',
		icon   : 'dumbbell',
		colorTw: 'white'
	},
	apple_stand_time            : {
		name   : 'Apple Stand Time',
		type   : 'apple_stand_time',
		icon   : 'walking',
		colorTw: 'white'
	},
	step_count                  : {
		name   : 'Step Count',
		type   : 'step_count',
		icon   : 'walking',
		colorTw: 'white'
	},
	basal_energy_burned         : {
		name   : 'Basal Energy Burned',
		type   : 'basal_energy_burned',
		icon   : 'fire',
		colorTw: 'white'
	},
	time_in_daylight            : {
		name   : 'Time in Daylight',
		type   : 'time_in_daylight',
		icon   : 'sun',
		colorTw: 'white'
	},
	dietary_water               : {
		name   : 'Dietary Water',
		type   : 'dietary_water',
		icon   : 'droplet',
		colorTw: 'sky'
	},
	blood_oxygen_saturation     : {
		name   : 'Blood Oxygen Saturation',
		type   : 'blood_oxygen_saturation',
		icon   : 'heart',
		colorTw: 'white'
	},
	environmental_audio_exposure: {
		name   : 'Environmental Audio Exposure',
		type   : 'environmental_audio_exposure',
		icon   : 'volume',
		colorTw: 'amber'
	},
	handwashing                 : {
		name   : 'Handwashing',
		type   : 'handwashing',
		icon   : 'hands-wash',
		colorTw: 'white'
	},
	headphone_audio_exposure    : {
		name   : 'Headphone Audio Exposure',
		type   : 'headphone_audio_exposure',
		icon   : 'headphones',
		colorTw: 'amber'
	},
	respiratory_rate            : {
		name   : 'Respiratory Rate',
		type   : 'respiratory_rate',
		icon   : 'lungs',
		colorTw: 'white'
	},
	toothbrushing               : {
		name   : 'Toothbrushing',
		type   : 'toothbrushing',
		icon   : 'toothbrush',
		colorTw: 'indigo'
	},
	weight_body_mass            : {
		name   : 'Weight Body Mass',
		type   : 'weight_body_mass',
		icon   : 'weight-scale',
		colorTw: 'white'
	},
	heart_alert                 : {
		name   : 'Heart Alert',
		type   : 'heart_alert',
		icon   : 'heart-circle-exclamation',
		colorTw: 'pink'
	},
	workout                     : {
		name   : 'Workout',
		type   : 'workout',
		icon   : 'sportsball',
		colorTw: 'sky'
	},
	sleep                       : {
		name   : 'Sleep',
		type   : 'sleep',
		icon   : 'face-sleeping',
		colorTw: 'neutral'
	},
	heart                       : {
		name   : 'Heart',
		type   : 'heart',
		icon   : 'heartbeat',
		colorTw: 'neutral'
	},
	rize                        : {
		name   : 'Rize',
		type   : 'rize',
		icon   : 'computer',
		colorTw: 'emerald'
	}
}
